import { Component, Input } from "@angular/core";

@Component({
  selector: "app-message-card",
  templateUrl: "./message-card.component.html",
})
export class MessageCardComponent {
  // Heading (title) text shown at the top of the SMS-style message card.
  @Input() heading = "Confirmed Appointment";
  // Body padding shorthand value used in the body paragraph's padding.
  @Input() bodyPadding = "0 51px 40px";
  // Body (message) text.
  @Input() body =
    "Your Appointment at [IC Name] is confirmed on [Date - Fri, Oct 25th, 2019] at [Time- 7 PM]. Please make sure to fill out any missing Personal, Insurance, and Physician information, as well as answering all Medical Questions before your exam. Follow link [Patient Card link]. Thank you for using [IC Name or SchedMed]";
}
